import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import moment from "moment";

const DuplicateCheckModal = ({ open, onClose, duplicateList, onSelectDuplicate }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon style={{ color: "#ff9800", fontSize: 28 }} />
          <Typography variant="h6">Phát hiện triển lãm trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các triển lãm có tiêu đề tương tự. Vui lòng kiểm tra:
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Tiêu đề</strong>
                </TableCell>
                <TableCell>
                  <strong>Đơn vị tổ chức</strong>
                </TableCell>
                <TableCell>
                  <strong>Ngày tổ chức</strong>
                </TableCell>
                <TableCell>
                  <strong>Thao tác</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicateList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.exhibition?.artworkName || ""}</TableCell>
                  <TableCell>{item.exhibition?.organizer || ""}</TableCell>
                  <TableCell>
                    {item.exhibition?.time ? moment(item.exhibition.time).format("DD/MM/YYYY") : ""}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="primary" size="small" onClick={() => onSelectDuplicate(item)}>
                      Chỉnh sửa
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateCheckModal;

